export default [
  {
    path: '/b2bhub/configuracao/ai-chat-config',
    name: 'ai-chat-config',
    component: () => import('@/views/app/configuracao/aiChatConfig/Index.vue'),
    meta: {
      pageTitle: 'Configuração da IA',
      action: 'manage',
      resource: 'AiChatConfig',
    },
  },
];
